module.exports = __webpack_public_path__ + "img/symphony_579_navy.faa6b860.jpg";